import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import commaNumber from 'comma-number';

import {fetchTaxInvoicesForCurrentUser} from '../../../actions/taxInvoices.actions';
import Button from '../../Common/Button';
import {PageContainer, PageDescription, PageTitle} from '../../Common/PageComponents';
import Table from '../../Common/Table';

const stateToProps = state => {
  return {
    taxInvoices: state.taxInvoices,
  };
};

class TaxInvoice extends Component {
  componentDidMount() {
    this.props.dispatch(fetchTaxInvoicesForCurrentUser(this._getCurrentYear()));
  }

  _changeYearClicked(e) {
    e.preventDefault();

    this.props.dispatch(fetchTaxInvoicesForCurrentUser(this.yearSelect.value));
    this.props.history.push('/my-pc-bang/tax-invoice/' + this.yearSelect.value);
  }

  _getCurrentYear() {
    if (this.props.match.params.year) {
      return parseInt(this.props.match.params.year);
    }

    return moment().year();
  }

  _openTaxInvoiceDocument(e, documentUrl) {
    e.preventDefault();

    window.open(documentUrl, '', 'width=920,height=668,scrollbars=yes,resize=yes');
  }

  _renderTaxInvoiceRow() {
    let taxInvoices = this.props.taxInvoices;

    if (!taxInvoices || taxInvoices.length == 0) {
      return (
        <tr>
          <td colSpan="6" style={{textAlign: 'center'}}>
            세금계산서 내역이 없습니다.
          </td>
        </tr>
      );
    }

    return taxInvoices.map((taxInvoice, index) => (
      <tr key={index}>
        <td>{moment(taxInvoice.issuedAt).month() + 1}월</td>
        <td>{moment(taxInvoice.issuedAt).format('YYYY-MM-01')}</td>
        <td>{moment(taxInvoice.issuedAt).format('YYYY-MM-') + moment(taxInvoice.issuedAt).daysInMonth()}</td>
        <td>{commaNumber(taxInvoice.totalSuppliedPrice)}원</td>
        <td>{commaNumber(taxInvoice.totalVat)}원</td>
        <td>
          <a
            href="#"
            onClick={e => this._openTaxInvoiceDocument(e, taxInvoice.documentUrl)}
            style={{textDecoration: 'underline'}}
          >
            {commaNumber(taxInvoice.totalSuppliedPrice + taxInvoice.totalVat)}원
          </a>
        </td>
      </tr>
    ));
  }

  _renderYearOptions() {
    let yearSelectItems = [];
    let recentYear = moment().year();

    for (let year = 2011; year <= recentYear; year++) {
      yearSelectItems.push(
        <option key={year} value={year}>
          {year}년
        </option>
      );
    }

    return yearSelectItems;
  }

  render() {
    return (
      <PageContainer>
        <PageTitle title="세금 계산서" />
        <PageDescription>라이엇 게임즈 프리미엄 PC방 세금계산서 발행내역입니다.</PageDescription>
        <div>
          <div className="account-settlements-search-form">
            <select
              ref={select => (this.yearSelect = select)}
              name="ctl00$ContentPlaceHolder1$ddlbYears"
              className="year-selection"
              defaultValue={this._getCurrentYear()}
            >
              {this._renderYearOptions()}
            </select>
            &nbsp;
            <Button size="small" onClick={e => this._changeYearClicked(e)}>
              검색
            </Button>
          </div>
          <br />
          <Table>
            <colgroup>
              <col width="65" />
              <col width="90" />
              <col width="90" />
              <col width="92" />
              <col width="92" />
              <col width="92" />
            </colgroup>
            <thead>
              <tr className="account-settlements-columns">
                <th>월</th>
                <th>정산시작일</th>
                <th>정산종료일</th>
                <th>게임이용료</th>
                <th>부가가치세</th>
                <th>총액</th>
              </tr>
            </thead>
            <tbody>{this._renderTaxInvoiceRow()}</tbody>
          </Table>
        </div>
      </PageContainer>
    );
  }
}

export default connect(stateToProps)(TaxInvoice);
